import Vue from 'vue';
import { formatOddDisplay, formatCurrency } from '@bto-services/utils';

/**
 * Global filter for formating odds display
 */
Vue.filter('formatOddDisplay', (value, format) => formatOddDisplay(value, format));

/**
 * Global filter for amount formating
 */
Vue.filter('formatAmountDisplay', (value, curCode, _noDec) => formatCurrency(value, curCode));
